/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import {
  FieldValues, SubmitHandler,
} from 'react-hook-form';
import LoadingButton from '@mui/lab/LoadingButton';
import {
  Alert,
  AlertTitle,
  TextField,
  Button,
  Stack,
  MenuItem,
  Box,
} from '@mui/material';
import { zodResolver } from '@hookform/resolvers/zod';
import { ApiError } from '@marageti/z4-sdk/lib/tracking';
import {
  useForm,
  getFieldProps,
  getFormProps,
  getSubmitButtonProps,
} from '@marageti/z4-lib';
import { MatchCancelSchema } from './trip-request-edit-form-util';

type MatchCancelProps = {
  onCancel: () => void;
  onSubmit: SubmitHandler<FieldValues>;
  reasonOptions: string[];
  submissionError?: ApiError;
};

const TripRequestEditForm = ({
  onCancel,
  onSubmit,
  reasonOptions,
  submissionError = undefined,
}: MatchCancelProps) => {
  const {
    handleSubmit,
    formState: { errors, isSubmitting, isValid },
    register,
  } = useForm({
    resolver: zodResolver(MatchCancelSchema),
  });

  return (
    <Box component="form" name="match-cancel-form" {...getFormProps(handleSubmit(onSubmit))} width="100%">
      <Stack spacing={2}>
        <TextField
          defaultValue={reasonOptions[0]}
          label="Reason"
          select
          {...register('reason', { required: 'Please select a reason' })}
          {...getFieldProps('reason', errors)}
        >
          {reasonOptions.map((option) => (
            <MenuItem key={option} value={option}>{option}</MenuItem>
          ))}
        </TextField>
        <TextField
          label="Comments"
          multiline
          rows={7}
          {...register('comments')}
          {...getFieldProps('comments', errors)}
        />
        {submissionError && (
          <Alert severity="error">
            <AlertTitle>There was an error on our end.</AlertTitle>
            {`Code: ${submissionError.code}: ${submissionError.message}`}
            <br />
            {submissionError.id && `ID: ${submissionError.id}`}
          </Alert>
        )}
        <Stack direction="row" spacing={2} mt="24px">
          <LoadingButton
            variant="contained"
            type="submit"
            {...getSubmitButtonProps(isSubmitting, isValid)}
          >
            Submit
          </LoadingButton>
          <Button variant="outlined" onClick={onCancel}>Cancel</Button>
        </Stack>
      </Stack>
    </Box>
  );
};

export default TripRequestEditForm;
